var exports = {
  "k": "xe7b6e3d6--5ce952--container",
  "K": "xe7b6e3d6--5ce952--icon",
};

module.exports = exports;
